"use strict";
const MIN_COL_SPAN = 1;
const MAX_COL_WIDTH = 100;
export {
  MAX_COL_WIDTH,
  MIN_COL_SPAN
};
